import type { CCSaveCommonParametersType } from "../../../common-deprecated/types/CommonTypes";

// Currently only the following keys are supported from makolab's side
export enum ExternalConfigAdditionalInfo {
    Registration = "Registration",
    Tax = "Tax",
    Delivery = "Delivery",
    Plates = "Plates",
}

/**
 * This object is used to pass all new cars vehicle data between external services, for example:
 * - We send it to CCSave service to generate a tyCode
 * - We pass it to Makolabs Finance/Insurance calculator when opening their modal
 *
 * The (new cars) response from the CCSave service is typed as part of the save reducer.
 * Used/Stock cars alternatives are present in tyCodeUtils.ts
 */
export type ExternalConfigType = {
    Brand: string; // capitalization is not guaranteed
    Country: string;
    Language: string;
    ModelID: string;
    CarID: string;
    ExteriorColourID: string;
    UpholsteryID: string;
    ProductType?: string;
    Packs?: string[];
    ServiceProducts?: string[];
    Options?: string[];
    Accessories?: string[];
    Promotions?: string[];
    TotalPrice?: number;
    TotalPriceInclPromotions?: number;
    Parameters?: CCSaveCommonParametersType & {
        TradeInValue?: number;
        Specifications?: {
            Co2?: number;
            AdditionalInfo?: Record<ExternalConfigAdditionalInfo, number>;
        };
        DealerId?: string;
        FinancePacks?: Record<string, string[]>;
        HomeChargingType?: "buy" | "rent" | "interested";
    };
    PSLS?: Record<string, any>;
    Costs?: {
        Name: string;
        Amount: number;
        TaxDefCode?: string;
        Code: string;
        Selected: boolean;
    }[];
    ExcludeMountingCosts?: string[];
};
